import { useCallback, useState, useEffect } from "react";
import { useUserContext } from "../../contexts/UserContext";
import { catchError } from "../../services/DaoService";
import { Button, Input, Spin, Empty } from "antd";
import { PlusCircleFilled, ReloadOutlined, SearchOutlined } from "@ant-design/icons";
import { MembreAffaireService } from "../../services/MembreAffaireService";
import MembreAffaireCreateForm from "./MembreAffaireCreateForm";
import MembreAffaireList from "./MembreAffaireList";
import PropTypes from "prop-types";
import styles from "./MembreAffaireByAffaireList.module.scss";

export default function MembreAffaireByAffaireList({ affaire, isReadOnly = true, canManage = false }) {
  const [paginationData, setPaginationData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [newModalVisible, setNewModalVisible] = useState(false);
  const { check } = useUserContext();
  const [searchText, setSearchText] = useState('');
  const [membreAffaires, setMembreAffaires] = useState([]);

  const init = useCallback(() => {
    setLoading(true);
    MembreAffaireService.getInstance()
      .search({ searchText: searchText || null, affaire_id: affaire.id })
      .then(r => { setPaginationData(r.data); setMembreAffaires(r.data.data); })
      .catch(catchError)
      .finally(() => setLoading(false));
  }, [searchText, affaire]);

  useEffect(() => { init(); }, [init, check]);

  return (
    <div className={styles.section}>
      <div className={styles.toolbar}>
        {paginationData?.total != null && (
          <span className={styles.count}>{paginationData.total}</span>
        )}
        <div className={styles.search}>
          <Input
            prefix={<SearchOutlined style={{ color: '#8C9BAB' }} />}
            placeholder="Rechercher..."
            value={searchText}
            onChange={e => setSearchText(e.target.value)}
            size="small"
            allowClear
          />
        </div>
        <div className={styles.actions}>
          <Button size="small" icon={<ReloadOutlined />} onClick={init} />
          {canManage && !isReadOnly && (
            <Button size="small" type="primary" icon={<PlusCircleFilled />} onClick={() => setNewModalVisible(true)}>
              Ajouter
            </Button>
          )}
        </div>
      </div>

      <Spin spinning={loading}>
        {membreAffaires.length === 0 && !loading
          ? <div style={{ padding: '16px 14px' }}><Empty description="Aucun collaborateur" image={Empty.PRESENTED_IMAGE_SIMPLE} /></div>
          : <MembreAffaireList
              isReadOnly={isReadOnly}
              canManage={canManage}
              membreAffaires={membreAffaires}
              setMembreAffaires={setMembreAffaires}
              paginationData={paginationData ?? { data: [] }}
              setPaginationData={setPaginationData}
              searchParams={{ searchText: searchText || null, affaire_id: affaire.id }}
            />
        }
      </Spin>

      {affaire && (
        <MembreAffaireCreateForm
          affaire={affaire}
          visible={newModalVisible}
          onCreate={init}
          onCancel={() => setNewModalVisible(false)}
        />
      )}
    </div>
  );
}

MembreAffaireByAffaireList.propTypes = {
  affaire: PropTypes.object.isRequired,
  isReadOnly: PropTypes.bool,
  canManage: PropTypes.bool,
};
